import type { LlmEntry } from "../config";

export function LLMSelector({
  available,
  selected,
  onChange,
  disabled,
}: {
  available: LlmEntry[];
  selected: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
}) {
  function toggle(id: string) {
    if (selected.includes(id)) {
      onChange(selected.filter((s) => s !== id));
    } else {
      onChange([...selected, id]);
    }
  }

  if (available.length === 0) {
    return (
      <div className="field">
        <label>Models</label>
        <div className="muted" style={{ fontSize: 12 }}>
          This service token is not scoped to any models.
        </div>
      </div>
    );
  }

  return (
    <div className="field" data-testid="llm-selector">
      <label>
        Participating models{" "}
        <span className="muted" style={{ textTransform: "none", letterSpacing: 0 }}>
          (select at least two)
        </span>
      </label>
      <div className="llm-grid">
        {available.map((llm) => {
          const checked = selected.includes(llm.id);
          return (
            <label
              key={llm.id}
              className={`llm-item${checked ? " checked" : ""}`}
              data-testid={`llm-${llm.id}`}
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => toggle(llm.id)}
                disabled={disabled}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 15, fontWeight: 600 }}>{llm.label}</div>
                <div
                  className="mono"
                  style={{ fontSize: 11, color: "var(--text-mute)", marginTop: 2 }}
                >
                  {llm.id}
                </div>
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}
